import { useEffect, useState } from 'react';
import { breakpoints } from '../mediaStyles';

const QUERY = `(max-width: ${breakpoints.tablet - 1}px)`;

const mediaQueryList = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY)
    : null;

function useIsMobileDisplay() {
  const [isMobile, setIsMobile] = useState(() => mediaQueryList()?.matches ?? false);

  useEffect(() => {
    const mql = mediaQueryList();
    if (!mql) {
      return undefined;
    }
    const listener = (e) => setIsMobile(e.matches);
    mql.addEventListener?.('change', listener);
    // Safari < 14 fallback
    mql.addListener?.(listener);
    return () => {
      mql.removeEventListener?.('change', listener);
      mql.removeListener?.(listener);
    };
  }, []);

  return isMobile;
}

export default useIsMobileDisplay;
